export const playerErrorCodes = {
  UNKNOWN_ERROR: "",
  NO_SUCH_FILE_ERROR: "571120",
  CONNECTION_ERROR: "571121",
  INVALID_PARAMETER: "571123",
  INVALID_OPERATION: "571124",
  SEEK_ERROR: "571125",
  INVALID_STATE: "571126",
  NOT_SUPPORTED_FILE: "571127",
  INVALID_URI: "571128",
  RESOURCE_LIMIT_ERROR: "571129",
  NOT_SUPPORTED_AUDIO_CODEC: "571130",
  NOT_SUPPORTED_VIDEO_CODEC: "571131",
  NO_AUTH_ERROR: "571132",
  GENERIC_ERROR: "571133",
  RESTORE_ERROR: "571134",
  NOT_SUPPORTED_FORMAT: "571135",
  SECURITY_ERROR: "571136",
  default: "571137"
};
